import React from "react";
import {Link } from "react-router-dom";
import Tdata from "../Data/Tdata";
function Trending() {
  return (
    <div className="container">
      <div className="row pt-4">
        <div className="col-lg-12">
          <div className="border py-3">
            <h2 className=" me-2 ps-4 "><span className="a">TRENDING NEWS</span></h2>
            <div className="row pt-2 px-3 mb-5">
              {Tdata.slice(0,4).map((a) => (
                <div className="col-lg-6 mt-5">
                  <div className="card">
                    <img className="w-100 image owl" src={a.image} />
                    <div className='zoom text-center'>
              <Link to={`/details/${a.id}`}>
                <i className="bi bi-arrow-right add rounded-circle text-light"></i></Link>
                </div>  
                    <div className="card-body">
                      <Link to={`/details/${a.id}`}>
                        <h5 className="text-dark fw-semibold">{a.title}</h5>
                      </Link>
                      <div className="d-flex text-secondary">
                        <i class="bi bi-clock-fill fs-6"></i>
                        <p className=" ps-2">November 16 , 2021</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Trending;
